import { getStripeInstance } from 'utils/stripe';
import axiosDeqart, { axiosDeqartSimple } from '../axios';

export const getPayments = () => async () => {
  try {
    const { data } = await axiosDeqart.get('/payments');
    return data;
  } catch (err) {
    console.log('An error occurred while fetching user payments');
    console.log(err);
    return err;
  }
};

export const getBalance = () => async () => {
  try {
    const { data } = await axiosDeqart.get('/balance');
    return data?.data;
  } catch (err) {
    console.log('An error occurred while fetching user payments');
    console.log(err);
    return err;
  }
};

export const getUsage = () => async () => {
  try {
    const { data } = await axiosDeqartSimple.get('/usage');
    return data.data;
  } catch (err) {
    console.log('An error occurred while fetching user payments');
    console.log(err);
    return err;
  }
};

export const addPaymentMethod = async () => {
  try {
    const response = await axiosDeqart.post(
      '/payment-methods',
      {},
    );
    return response.data.clientSecret;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const updateBillingDetails = async (data) => {
  try {
    const { paymentMethodId, ...rest } = data;
    const response = await axiosDeqart.put(
      `/payment-methods/${paymentMethodId}`,
      { ...rest },
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getPaymentMethod = async () => {
  try {
    const { data: { data } } = await axiosDeqart.get('/payment-methods');
    return data[0];
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const removePaymentMethod = async (paymentMethodId) => {
  try {
    const response = await axiosDeqart.delete(`/payment-methods/${paymentMethodId}`);
  } catch (err) {
    console.log(err);
  }
};

export const addBalance = async (amount, paymentMethod) => {
  try {
    const response = await axiosDeqart.post(
      '/payments',
      {
        amount: Number(amount),
        paymentMethodId: paymentMethod.id,
      },
    );

    if (response.status !== 200) {
      const stripe = await getStripeInstance();

      const stripeResponse = await stripe.confirmCardPayment(response.data.clientSecret);

      return {
        ...stripeResponse,
        success: true,
      };
    }

    return {
      ...response,
      success: true,
    };
  } catch (error) {
    console.log(error);
    return {
      error: error.message || error,
      success: false,
    };
  }
};

export const redeemCoupon = async (coupon) => {
  try {
    const { data: { data: { exceedsPromoBalanceLimit } } } = await axiosDeqart.post(`/coupons/apply/${coupon}`, {});
    if (exceedsPromoBalanceLimit) {
      throw new Error('Promo balance limit exceeded.');
    }
    return {
      exceedsPromoBalanceLimit,
      success: !exceedsPromoBalanceLimit,
    };
  } catch (error) {
    const reason = error.response?.data
      ? error.response.data.errorMessage
      : error.message;
    return {
      error: reason,
      success: false,
    };
  }
};
